export default {
  setTopTenCriminals(state, payload) {
    state.topTenCriminals = payload.value;
  },
  setTopTenCrimes(state, payload) {
    state.topTenCrimes = payload.value;
  },
   setTopTenSentences(state, payload) {
    state.topTenSentences = payload.value;
  },
  setCriminalsSoap(state, payload) {
    state.criminalsSoap = payload.value;
  },
  setCrimesSoap(state, payload) {
    state.crimesSoap = payload.value;
  },
  setSentencesSoap(state, payload) {
    state.sentencesSoap = payload.value;
  },
  toggleCrimeDetails(state) {
    state.isShowCrimeDetails = !state.isShowCrimeDetails;
  },
  toggleSentenceDetails(state) {
    state.isShowSentenceDetails = !state.isShowSentenceDetails;
  }
};
